import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ticketApi } from '../../api/ticket.api';
import { usePolling } from '../../hooks/useDraft';
import { useAuth } from '../../store/AuthContext';
import { useUI } from '../../store/UIContext';
import { isEmployee, isWorkspaceRole } from '../../utils/roleHelpers';

function ticketPath(userType, ticketId) {
  if (!ticketId) return null;
  return isWorkspaceRole(userType) ? `/tickets/${ticketId}/process` : `/tickets/${ticketId}`;
}

export default function ReferralInboxPoller() {
  const { user } = useAuth();
  const { addToast } = useUI();
  const navigate = useNavigate();
  const shownRef = useRef(new Set());
  const permissionAsked = useRef(false);
  const enabled = isEmployee(user?.type);

  const poll = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await ticketApi.getInboxNotifications();
      const list = res.data?.notifications || [];
      if (!list.length) return;

      if (
        !permissionAsked.current
        && typeof Notification !== 'undefined'
        && Notification.permission === 'default'
      ) {
        permissionAsked.current = true;
        try { await Notification.requestPermission(); } catch {}
      }

      const ids = list.map((n) => n.id).filter(Boolean);
      const unseen = list.filter((n) => !shownRef.current.has(n.id));
      for (const n of unseen) shownRef.current.add(n.id);

      if (unseen.length) {
        const latest = unseen[unseen.length - 1];
        const msg = latest.message || 'یک پیام داری';
        addToast(msg, 'info', 8000);
        if (typeof Notification !== 'undefined' && Notification.permission === 'granted') {
          try {
            const note = new Notification('پژواک CRM', { body: msg, tag: 'inbox-referral' });
            const href = ticketPath(user?.type, latest.ticket_id);
            if (href) {
              note.onclick = () => {
                window.focus();
                navigate(href);
              };
            }
          } catch {}
        }
      }
      if (ids.length) {
        await ticketApi.markInboxSeen({ ids });
      }
    } catch {}
  }, [enabled, user?.type, addToast, navigate]);

  usePolling(poll, 10000, enabled);
  return null;
}
